exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-toggle {\r\n    background: var(--main-danger-hover);\r\n    color: #fff;\r\n}\r\ntable, table button {\r\n    font-size: 14px;\r\n}\r\ntable button {\r\n    padding: .35rem .75rem !important;\r\n}\r\n.input-group-addon:active {\r\n    background-color: #555;\r\n    border-color: #000;\r\n    color: #eee;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/prestamos/detalle/detalle-prestamo/detalle-prestamo.component.css
// module id = ../../../../../src/app/components/prestamos/detalle/detalle-prestamo/detalle-prestamo.component.css
// module chunks = main